import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { useFeature } from "~/core/composables/useFeature";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { AppFeatures } from "~/core/models/AppFeatures.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import {
  PATH_PARAMETERS_FIRMWARES,
  PATH_PARAMETERS_FIRMWARES_UUID,
} from "~/modules/firmware/constants";
import FirmwaresPage from "~/modules/firmware/views/FirmwaresPage.vue";

const { isFeatureEnabled } = useFeature();

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_FIRMWARES,
    component: FirmwaresPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_FIRMWARE),
      breadcrumb: BREADCRUMBS.PARAMETERS,
    },
  },
  {
    path: PATH_PARAMETERS_FIRMWARES_UUID,
    component: FirmwaresPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_FIRMWARE),
      breadcrumb: BREADCRUMBS.PARAMETERS,
    },
  },
];

export default routes;
